/** Display formatting in the workspace's locale and currency. */
import { formatMoney } from "@sable/domain";
import { currentLocale } from "../i18n/index.ts";

export function money(minor: number | null | undefined, currency: string): string {
  return formatMoney(minor, currency, currentLocale());
}

export function shortDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = iso.length === 10 ? new Date(`${iso}T12:00:00`) : new Date(iso);
  return d.toLocaleDateString(currentLocale(), { month: "short", day: "numeric", year: d.getFullYear() === new Date().getFullYear() ? undefined : "numeric" });
}

export function monthLabel(yyyyMm: string): string {
  const [y, m] = yyyyMm.split("-").map(Number);
  return new Date(y!, m! - 1, 15).toLocaleDateString(currentLocale(), { month: "short", year: "numeric" });
}

export function percent(value: number): string {
  return new Intl.NumberFormat(currentLocale(), { style: "percent", maximumFractionDigits: 0 }).format(value);
}

/** Today in the given IANA time zone, as YYYY-MM-DD. */
export function todayIn(timeZone: string): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
}
